import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { refundAirFareFeeRequest, refundAirFareFeeRequestSuccess, refundAirFareFeeRequestFailure, fdCompensationRequest, fdCompensationSuccess, fdCompensationFailure } from "../slice/refundAirFareFeeSlice";
import { config } from "../../../config/global";
const REFUNDAIRFAREFEE_REQUEST_URL = config.REFUNDAIRFAREFEE_REQUEST;
const FD_COMPENSATION_REQUEST_URL = config.FD_COMPENSATION_REQUEST;
const refundAirFareFeeRequestData = async payload => {
  const data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true
  };
  const response = await api.post(REFUNDAIRFAREFEE_REQUEST_URL, payload, data);
  return response;
};
function* getRefundAirFareFeeRequest(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(refundAirFareFeeRequestData, payload);
    yield put(refundAirFareFeeRequestSuccess(response.data));
  } catch (error) {
    yield put(refundAirFareFeeRequestFailure(error));
  }
}
export function* watchRefundAirFareFeeRequest() {
  yield takeLatest(refundAirFareFeeRequest.type, getRefundAirFareFeeRequest);
}
const fdCompensationRequestData = async payload => {
  const data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true
  };
  const response = await api.post(FD_COMPENSATION_REQUEST_URL, payload, data);
  return response;
};
function* getFdCompensationRequest(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(fdCompensationRequestData, payload);
    yield put(fdCompensationSuccess(response.data));
  } catch (error) {
    yield put(fdCompensationFailure(error));
  }
}
export function* watchFdCompensationRequest() {
  yield takeLatest(fdCompensationRequest.type, getFdCompensationRequest);
}